/* eslint-disable */
/**
 * Create styles for `<MoreMenu />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<MoreMenu />` styles
 */
const moreMenuStyles = ({ theme }) => ({
  paper: {
    right: theme.spacing(2),
    // overwrite "style" applied to component, doesn't seem to work after switching from materialUI 4v, couldn't figure out any easier way, porops do not seem to help
    left: `auto !important`,
  }
});

export default moreMenuStyles;
